import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
@Component({
  selector: 'calculator-form',
  templateUrl: './calculator-form.component.html',
  styleUrls: ['./calculator-form.component.css']
})
export class CalculatorFormComponent implements OnInit {
  loan_amount=1900000;
  loan_tenure=150;
  simple_interest=9.55;
  sweet_short_intrest=10;
  table_data;
  intreset_simple;
  monthly_payment;
  table_shown:boolean=false;
  show_submit:boolean=false;
  data=[];
  emi;
constructor(
    fb: FormBuilder
  ) {
   }

  ngOnInit() {
  }
  ngOnChanges(){
    
  }
  
  generatetable(loan_amount,loan_tenure,simple_interest,sweet_interest){
   
    if(loan_amount&&loan_tenure&&simple_interest&&sweet_interest){
          this.table_shown=true;
          this.show_submit=true;
          if(this.data.length>0){
            this.data.length=0;
          }
          let balance_amount=loan_amount;
          this.emi=this.CalculateEmi(loan_amount,simple_interest,loan_tenure);
          for(let i=1;i<=loan_tenure;i++){
            let table_data=this.simpleLoanTable(i,balance_amount,simple_interest,loan_tenure,balance_amount);
            balance_amount=table_data.balance_amount-table_data.principal;
            this.data.push(table_data);
          }
          return this.data;
      }else{
        this.show_submit=false;
         }
    }

    simpleLoanTable(month_id,amount,roi,tenure,balance_amount){
      
      let intreset_simple=this.CalculateInterest(amount,roi);
      let table_data={
        id:month_id,
        emi: this.emi,
        intreset_simple:intreset_simple,
        principal:this.emi-intreset_simple,
        balance_amount:balance_amount,
      };
      return table_data;
    }


  CalculateEmi(amount,interest,tenure){
     //debugger
     interest=interest/1200;
     let numertor   =interest*(-amount)*Math.pow(1+interest,tenure);
     let denominator=1-(Math.pow(1+interest,tenure));
     return Math.round((numertor)/(denominator));
   }
   CalculateMonthlyPayment(amount,interest,periods){
    // debugger;
    let numertor=amount*interest*Math.pow(1+interest,periods);
    let denominator=(Math.pow(1+interest,periods))+1;
    return Math.round((numertor)/(denominator)); 
   }
   CalculateInterest(amount,rate){
    // debugger;
       return Math.round((amount*rate)/1200);
   }
     
}



// WEBPACK FOOTER //
// ./src/app/calculators/short-sweet/calculator-form/calculator-form.component.ts